module.exports = __webpack_public_path__ + "img/murloc_assassin_small.135ade7d.png";